import { stubbedCustomRouteMap } from './stubbedCustomRouteMap';

export const stubbedGetCustomRouteResponse = {
  route: {
    id: 53450256,
    slug: 'map-february-26-2025-13111c2',
    bounds: {
      longitudeTopLeft: -98.86778,
      latitudeTopLeft: 38.20333,
      longitudeBottomRight: -98.76226,
      latitudeBottomRight: 38.09996
    },
    name: 'Map - February 26, 2025',
    description: 'test - update3',
    contentPrivacy: 'urn:alltrails:visibility:public',
    activityType: 'hiking',
    distance: 43404.56,
    elevationGain: 66,
    estimatedTime: {
      value: '8–9',
      unit: 'hr'
    },
    segments: [
      {
        id: 0,
        serverId: 53450256000,
        color: '#f87559',
        elevationPoints: [
          [
            0,
            586,
            [38.20333, -98.81078],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            0,
            586,
            [38.20328, -98.81078],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5.55975401186121,
            586,
            [38.20329, -98.81164],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            80.71433116467763,
            585,
            [38.20329, -98.81249],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            154.98688204633936,
            585,
            [38.20329, -98.81307],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            205.66697558917147,
            585,
            [38.20329, -98.81365],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            256.3470691320036,
            585,
            [38.20329, -98.81423],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            307.0271626748357,
            585,
            [38.20328, -98.8148],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            356.84587580786194,
            585,
            [38.20328, -98.81538],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            407.52597631211586,
            586,
            [38.20328, -98.81596],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            458.2060768163698,
            586,
            [38.20328, -98.81654],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            508.8861773206237,
            586.52,
            [38.20328, -98.81712],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            559.5662778248776,
            587,
            [38.20328, -98.8177],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            610.2463783291315,
            587,
            [38.20328, -98.81828],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            660.9264788333854,
            587,
            [38.20328, -98.81886],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            711.6065793376393,
            588,
            [38.20327, -98.81943],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            761.4252993090987,
            588,
            [38.20327, -98.82001],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            812.105406774773,
            588,
            [38.20327, -98.82059],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            862.7855142404472,
            587.25,
            [38.20327, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            913.4656217061215,
            587,
            [38.20272, -98.82118],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            974.6291578086255,
            587.26,
            [38.20217, -98.82118],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1035.7864519367286,
            588,
            [38.20162, -98.82119],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1096.9499882278476,
            588,
            [38.20112, -98.82118],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1152.5543947479798,
            588,
            [38.20063, -98.82118],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1207.0399840631135,
            588,
            [38.20014, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1261.5325800837713,
            588,
            [38.19964, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1317.136986883024,
            588,
            [38.19917, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1369.4059796126012,
            588,
            [38.19869, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1422.7796181250467,
            588,
            [38.19822, -98.82118],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1475.0486110452532,
            588,
            [38.19774, -98.82118],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1528.4222495569086,
            588,
            [38.19726, -98.82118],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1581.795888069354,
            588,
            [38.19677, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1636.2884847385792,
            588,
            [38.19629, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1689.6621232510247,
            588,
            [38.1958, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1744.154720106906,
            588,
            [38.19532, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1797.5283586185615,
            588,
            [38.19484, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1850.9091508332294,
            588,
            [38.19435, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1905.394740147573,
            588,
            [38.19387, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1958.7755325528021,
            588,
            [38.19338, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2013.2611218671457,
            588,
            [38.1929, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2066.6419144621445,
            589,
            [38.19244, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2117.7916513700034,
            589,
            [38.19198, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2168.9413882770723,
            589.48,
            [38.19151, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2221.210382543535,
            590,
            [38.19105, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2272.360119451394,
            590,
            [38.19059, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2323.509856358463,
            590,
            [38.19013, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2374.659593265532,
            589,
            [38.18966, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2426.928587903155,
            588,
            [38.1892, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2478.0783248110138,
            588,
            [38.18874, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2529.2280617180827,
            588,
            [38.1881, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2600.39291306801,
            588,
            [38.18746, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2671.557764417147,
            588,
            [38.18738, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2680.4962018436477,
            588,
            [38.18693, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2730.5339879488183,
            588,
            [38.18648, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2780.571774053199,
            588,
            [38.18603, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2830.617192552828,
            588,
            [38.18557, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2881.7669294606867,
            588,
            [38.18512, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2931.8047155658574,
            588,
            [38.18467, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2981.842501671028,
            588,
            [38.18422, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3031.887920549119,
            588,
            [38.18377, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3081.9257066542896,
            589,
            [38.18332, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3131.96349275946,
            590,
            [38.18286, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3183.113229667319,
            590,
            [38.18241, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3233.158648925424,
            589,
            [38.18196, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3283.196435030595,
            589,
            [38.18151, -98.82117],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3333.2342211349755,
            590,
            [38.18061, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3433.3136103051247,
            590,
            [38.18009, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3491.1416581807125,
            590,
            [38.17956, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3550.081532321022,
            589,
            [38.17909, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3602.3432200307793,
            589,
            [38.17862, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3654.6049077405364,
            588,
            [38.17815, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3706.8665954502935,
            588,
            [38.17768, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3759.135592491288,
            588,
            [38.1772, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3812.5092310037335,
            588,
            [38.17673, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3864.7709187134906,
            588,
            [38.17626, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3917.0326064232477,
            588,
            [38.17579, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3969.2942941330048,
            588,
            [38.1752, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4034.905214694184,
            588,
            [38.1746, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4101.627989105445,
            588,
            [38.17453, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4109.411644721892,
            588,
            [38.17427, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4138.335577783971,
            588,
            [38.17381, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4189.485314691039,
            588,
            [38.17335, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4240.635051598898,
            588,
            [38.17288, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4292.896739308655,
            588,
            [38.17242, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4344.0464762157235,
            588,
            [38.17196, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4395.196213123582,
            588,
            [38.1715, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4446.345950030651,
            588,
            [38.17103, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4498.607637740408,
            588,
            [38.17057, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4549.757374648267,
            588,
            [38.17011, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4600.907111555335,
            588,
            [38.16965, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4652.056848463194,
            588,
            [38.16919, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4703.214055318169,
            588,
            [38.16874, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4753.25184142334,
            588,
            [38.16828, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4804.409048464819,
            588,
            [38.16782, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4855.558785372677,
            588,
            [38.16775, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4863.342440989125,
            588,
            [38.16722, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4922.275833512642,
            588,
            [38.16668, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4982.327540686491,
            588,
            [38.1663, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5024.581671175214,
            588,
            [38.16578, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5082.40972164538,
            588,
            [38.16526, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5140.231163366208,
            589,
            [38.16474, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5198.079036306007,
            590.22,
            [38.16422, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5255.926909622781,
            590.09,
            [38.16365, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5319.362349682708,
            589,
            [38.16336, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5351.608922950397,
            588,
            [38.16272, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5422.779144453958,
            588,
            [38.16208, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5493.943995803095,
            588,
            [38.16158, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5549.541535920127,
            588,
            [38.16108, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5605.145949991687,
            588,
            [38.16058, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5660.74349010793,
            588,
            [38.16001, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5724.1307158831905,
            589,
            [38.15965, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5764.160944767327,
            588,
            [38.15918, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5816.429945519226,
            588,
            [38.15871, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5868.698946365394,
            588,
            [38.15825, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5919.856155462418,
            588,
            [38.15778, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5972.125156495118,
            588,
            [38.15731, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6024.394157622065,
            588,
            [38.15684, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6076.66315884328,
            588,
            [38.15637, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6128.9321601587835,
            588,
            [38.1559, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6181.193847868541,
            588,
            [38.15543, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6233.462849372579,
            588,
            [38.15496, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6285.731850970883,
            588,
            [38.15451, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6335.769637076054,
            587,
            [38.154, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6392.4858684900355,
            587,
            [38.15348, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6450.307310211654,
            587,
            [38.15297, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6507.023541816017,
            587,
            [38.15245, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6564.851594702828,
            587,
            [38.15194, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6621.561085621758,
            587.66,
            [38.15142, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6679.38913869527,
            588,
            [38.1512, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6703.852056346511,
            588,
            [38.151, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6726.091072393166,
            588,
            [38.1505, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6781.750465473956,
            588,
            [38.15005, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6831.788251579127,
            588,
            [38.14956, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6886.280857332121,
            589,
            [38.14908, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6939.6831408414055,
            588,
            [38.14862, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6990.840351911836,
            587,
            [38.14811, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7047.549842830766,
            587,
            [38.14761, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7103.154259441886,
            586,
            [38.1471, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7159.863750360816,
            586,
            [38.14653, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7223.299215884148,
            586,
            [38.14596, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7286.734682254468,
            586,
            [38.14591, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7292.294436266329,
            587,
            [38.14552, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7335.66933374335,
            587,
            [38.14503, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7390.330085547127,
            587,
            [38.14454, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7444.815674861471,
            587.02,
            [38.14406, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7498.196477049215,
            588,
            [38.14357, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7552.682066364348,
            588,
            [38.1431, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7604.951070341251,
            588,
            [38.14262, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7658.3318728117465,
            588,
            [38.14215, -98.82113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7710.600876979166,
            588,
            [38.14168, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7762.869881240842,
            588,
            [38.1412, -98.82115],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7816.25068399099,
            589,
            [38.14073, -98.82116],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7868.519688443182,
            591,
            [38.14024, -98.82114],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7923.033345262246,
            591,
            [38.13975, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7977.582067000721,
            591.01,
            [38.13919, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8039.851311931512,
            590.1,
            [38.13862, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8103.238541243437,
            588,
            [38.13806, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8165.507786174228,
            587,
            [38.13759, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8217.769473883985,
            587,
            [38.13712, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8270.038479060124,
            587,
            [38.13665, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8322.30016676988,
            587,
            [38.13649, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8340.091379607362,
            587,
            [38.13592, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8403.472575340842,
            587,
            [38.13536, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8465.741820271633,
            587,
            [38.13479, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8529.123016004321,
            587,
            [38.13414, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8601.399818156147,
            587,
            [38.13374, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8645.886448847985,
            587,
            [38.13319, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8707.043742976877,
            587,
            [38.13263, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8769.337553554626,
            587,
            [38.13206, -98.82108],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8832.742884497153,
            587,
            [38.13148, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8897.241961753682,
            587,
            [38.1309, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8961.73510828985,
            587,
            [38.13052, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9003.989238778573,
            587,
            [38.13002, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9059.586778894814,
            587,
            [38.12952, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9115.184319011847,
            587,
            [38.12902, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9170.78185912888,
            586.02,
            [38.12852, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9226.379399245121,
            586,
            [38.12801, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9283.088890164052,
            586,
            [38.12751, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9338.686430281085,
            586,
            [38.12701, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9394.283970398117,
            586,
            [38.12651, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9449.881510514359,
            586,
            [38.12601, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9505.485931197218,
            587.07,
            [38.1255, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9562.195422116149,
            588,
            [38.125, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9617.799842989381,
            587.99,
            [38.12449, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9674.509333908312,
            588,
            [38.12398, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9731.225570870425,
            588,
            [38.12346, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9789.047012592044,
            588,
            [38.12295, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9845.76324974449,
            588,
            [38.12246, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9900.248839059625,
            587.34,
            [38.12198, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9953.629645582829,
            587,
            [38.12149, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10008.115234897172,
            587,
            [38.121, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10062.600824211515,
            587,
            [38.12052, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10115.981631022156,
            587,
            [38.12003, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10170.467220336499,
            587.93,
            [38.11945, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10234.960366871877,
            588,
            [38.11886, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10300.571296434538,
            588,
            [38.11839, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10352.832984144296,
            588,
            [38.11792, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10405.094671854053,
            587.57,
            [38.11746, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10456.251889308762,
            587,
            [38.11699, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10508.513577018519,
            587,
            [38.11652, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10560.775264728276,
            587,
            [38.11605, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10613.044274129326,
            587,
            [38.11558, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10665.305961839083,
            587,
            [38.11512, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10716.463179773951,
            587,
            [38.11466, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10767.61291668102,
            587,
            [38.1142, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10818.76265358888,
            587,
            [38.11374, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10869.912390495949,
            587,
            [38.11328, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10921.062127403018,
            587,
            [38.11281, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10973.323815112775,
            587,
            [38.11235, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11024.473552020634,
            587,
            [38.11189, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11075.623288927703,
            587,
            [38.11143, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11126.773025835562,
            587,
            [38.11097, -98.82109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11177.922762742632,
            587,
            [38.11051, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11229.079981621864,
            587,
            [38.11005, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11280.229718528934,
            587,
            [38.10959, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11331.379455436792,
            587,
            [38.10913, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11382.529192343862,
            587,
            [38.10867, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11433.67892925172,
            587,
            [38.10821, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11484.82866615879,
            587,
            [38.10774, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11537.090353868547,
            587.38,
            [38.10728, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11588.240090775616,
            587.08,
            [38.10682, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11639.389827683475,
            587,
            [38.10636, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11690.539564590545,
            587,
            [38.1059, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11741.689301498403,
            587,
            [38.10531, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11807.29439883568,
            587,
            [38.10473, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11871.787545371059,
            587,
            [38.10414, -98.8211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11937.392642709125,
            587,
            [38.10363, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11994.108883431405,
            588,
            [38.10311, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12051.930325153024,
            588,
            [38.1026, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12108.646566065585,
            588,
            [38.10206, -98.82112],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12168.69190939179,
            588,
            [38.10152, -98.82111],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12228.743627938795,
            587.18,
            [38.10152, -98.82225],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12328.495318197098,
            588,
            [38.10154, -98.8231],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12402.904808973311,
            588,
            [38.10155, -98.82394],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12476.414439777778,
            589,
            [38.10155, -98.82452],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12527.165278898412,
            589,
            [38.10155, -98.82509],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12577.041103549951,
            589,
            [38.10155, -98.82567],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12627.791942669342,
            589,
            [38.10156, -98.82625],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12678.554958275272,
            588,
            [38.10156, -98.82682],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12728.430776100859,
            588,
            [38.10156, -98.8274],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12779.181608274544,
            588,
            [38.10156, -98.82798],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12829.93244044823,
            588,
            [38.10156, -98.82856],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12880.683272621916,
            588,
            [38.10156, -98.82913],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12930.559090448747,
            588,
            [38.10157, -98.82971],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12981.322099110654,
            588,
            [38.10157, -98.83029],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13032.072924338632,
            589,
            [38.10157, -98.83086],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13081.948735338265,
            589,
            [38.10157, -98.83144],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13132.699560566243,
            588,
            [38.10156, -98.82753],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13132.699560566243,
            588,
            [38.10156, -98.82753],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13132.699560566243,
            588,
            [38.10156, -98.82818],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13189.575493175367,
            588,
            [38.10156, -98.82883],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13246.451425783247,
            588,
            [38.10157, -98.82949],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13304.213072683202,
            588,
            [38.10157, -98.83014],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13361.0889975071,
            589,
            [38.10157, -98.83079],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13417.964922330999,
            589,
            [38.10157, -98.83144],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13474.840847156142,
            589,
            [38.10157, -98.83144],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13474.840847156142,
            590.96,
            [38.10157, -98.83202],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13525.59167238412,
            590.03,
            [38.10157, -98.83259],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13575.467483383753,
            590,
            [38.10158, -98.83317],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13626.2304851016,
            590,
            [38.10158, -98.83375],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13676.981303383869,
            590,
            [38.10158, -98.83432],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13726.857107558792,
            590,
            [38.10158, -98.8349],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13777.607925841061,
            591,
            [38.10159, -98.83548],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13828.370920614881,
            591,
            [38.10159, -98.83605],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13878.246717962604,
            590.9,
            [38.10159, -98.83663],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13928.997529299162,
            590,
            [38.10159, -98.8372],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13978.873326646884,
            590,
            [38.10159, -98.83778],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14029.624137983443,
            591,
            [38.1016, -98.83836],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14080.387125813202,
            591,
            [38.1016, -98.83893],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14130.262916336209,
            591,
            [38.1016, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14181.013720727056,
            591,
            [38.10211, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14237.723211646777,
            591,
            [38.10261, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14293.320751763018,
            590.49,
            [38.10312, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14350.030242681949,
            591,
            [38.10362, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14405.627782798982,
            591,
            [38.10413, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14462.337273717912,
            591,
            [38.10464, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14519.046764637633,
            592,
            [38.10514, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14574.644304753874,
            592,
            [38.10565, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ]
        ],
        paths: [
          {
            points: [
              [38.20333, -98.81078],
              [38.20328, -98.81078],
              [38.20329, -98.81164],
              [38.20329, -98.81249],
              [38.20329, -98.81307],
              [38.20329, -98.81365],
              [38.20329, -98.81423],
              [38.20328, -98.8148],
              [38.20328, -98.81538],
              [38.20328, -98.81596],
              [38.20328, -98.81654],
              [38.20328, -98.81712],
              [38.20328, -98.8177],
              [38.20328, -98.81828],
              [38.20328, -98.81886],
              [38.20327, -98.81943],
              [38.20327, -98.82001],
              [38.20327, -98.82059],
              [38.20327, -98.82117],
              [38.20272, -98.82118],
              [38.20217, -98.82118],
              [38.20162, -98.82119],
              [38.20112, -98.82118],
              [38.20063, -98.82118],
              [38.20014, -98.82117],
              [38.19964, -98.82116],
              [38.19917, -98.82117],
              [38.19869, -98.82117],
              [38.19822, -98.82118],
              [38.19774, -98.82118],
              [38.19726, -98.82118],
              [38.19677, -98.82117],
              [38.19629, -98.82117],
              [38.1958, -98.82116],
              [38.19532, -98.82116],
              [38.19484, -98.82115],
              [38.19435, -98.82115],
              [38.19387, -98.82114],
              [38.19338, -98.82114],
              [38.1929, -98.82113],
              [38.19244, -98.82113],
              [38.19198, -98.82113],
              [38.19151, -98.82114],
              [38.19105, -98.82114],
              [38.19059, -98.82114],
              [38.19013, -98.82114],
              [38.18966, -98.82115],
              [38.1892, -98.82115],
              [38.18874, -98.82115],
              [38.1881, -98.82115],
              [38.18746, -98.82115],
              [38.18738, -98.82114],
              [38.18693, -98.82114],
              [38.18648, -98.82114],
              [38.18603, -98.82115],
              [38.18557, -98.82115],
              [38.18512, -98.82115],
              [38.18467, -98.82115],
              [38.18422, -98.82116],
              [38.18377, -98.82116],
              [38.18332, -98.82116],
              [38.18286, -98.82116],
              [38.18241, -98.82117],
              [38.18196, -98.82117],
              [38.18151, -98.82117],
              [38.18061, -98.82116],
              [38.18009, -98.82115],
              [38.17956, -98.82114],
              [38.17909, -98.82114],
              [38.17862, -98.82114],
              [38.17815, -98.82114],
              [38.17768, -98.82115],
              [38.1772, -98.82115],
              [38.17673, -98.82115],
              [38.17626, -98.82115],
              [38.17579, -98.82115],
              [38.1752, -98.82114],
              [38.1746, -98.82113],
              [38.17453, -98.82113],
              [38.17427, -98.82114],
              [38.17381, -98.82114],
              [38.17335, -98.82114],
              [38.17288, -98.82114],
              [38.17242, -98.82114],
              [38.17196, -98.82114],
              [38.1715, -98.82114],
              [38.17103, -98.82114],
              [38.17057, -98.82114],
              [38.17011, -98.82114],
              [38.16965, -98.82114],
              [38.16919, -98.82113],
              [38.16874, -98.82113],
              [38.16828, -98.82112],
              [38.16782, -98.82112],
              [38.16775, -98.82112],
              [38.16722, -98.82112],
              [38.16668, -98.82111],
              [38.1663, -98.82111],
              [38.16578, -98.82112],
              [38.16526, -98.82112],
              [38.16474, -98.82114],
              [38.16422, -98.82116],
              [38.16365, -98.82113],
              [38.16336, -98.82113],
              [38.16272, -98.82114],
              [38.16208, -98.82114],
              [38.16158, -98.82114],
              [38.16108, -98.82115],
              [38.16058, -98.82115],
              [38.16001, -98.82116],
              [38.15965, -98.82116],
              [38.15918, -98.82115],
              [38.15871, -98.82114],
              [38.15825, -98.82113],
              [38.15778, -98.82112],
              [38.15731, -98.82111],
              [38.15684, -98.82112],
              [38.15637, -98.82113],
              [38.1559, -98.82113],
              [38.15543, -98.82114],
              [38.15496, -98.82115],
              [38.15451, -98.82115],
              [38.154, -98.82114],
              [38.15348, -98.82114],
              [38.15297, -98.82113],
              [38.15245, -98.82112],
              [38.15194, -98.82112],
              [38.15142, -98.82111],
              [38.1512, -98.82111],
              [38.151, -98.82111],
              [38.1505, -98.82114],
              [38.15005, -98.82114],
              [38.14956, -98.82113],
              [38.14908, -98.82111],
              [38.14862, -98.8211],
              [38.14811, -98.8211],
              [38.14761, -98.82109],
              [38.1471, -98.82109],
              [38.14653, -98.82112],
              [38.14596, -98.82115],
              [38.14591, -98.82115],
              [38.14552, -98.82116],
              [38.14503, -98.82111],
              [38.14454, -98.82111],
              [38.14406, -98.8211],
              [38.14357, -98.8211],
              [38.1431, -98.82111],
              [38.14262, -98.82112],
              [38.14215, -98.82113],
              [38.14168, -98.82114],
              [38.1412, -98.82115],
              [38.14073, -98.82116],
              [38.14024, -98.82114],
              [38.13975, -98.82111],
              [38.13919, -98.82111],
              [38.13862, -98.8211],
              [38.13806, -98.8211],
              [38.13759, -98.8211],
              [38.13712, -98.82111],
              [38.13665, -98.82111],
              [38.13649, -98.82111],
              [38.13592, -98.82111],
              [38.13536, -98.82111],
              [38.13479, -98.82111],
              [38.13414, -98.82111],
              [38.13374, -98.82112],
              [38.13319, -98.82112],
              [38.13263, -98.8211],
              [38.13206, -98.82108],
              [38.13148, -98.82109],
              [38.1309, -98.82109],
              [38.13052, -98.82109],
              [38.13002, -98.82109],
              [38.12952, -98.82109],
              [38.12902, -98.82109],
              [38.12852, -98.82109],
              [38.12801, -98.82109],
              [38.12751, -98.82109],
              [38.12701, -98.82109],
              [38.12651, -98.82109],
              [38.12601, -98.8211],
              [38.1255, -98.8211],
              [38.125, -98.82111],
              [38.12449, -98.82111],
              [38.12398, -98.8211],
              [38.12346, -98.8211],
              [38.12295, -98.82109],
              [38.12246, -98.82109],
              [38.12198, -98.8211],
              [38.12149, -98.8211],
              [38.121, -98.8211],
              [38.12052, -98.82111],
              [38.12003, -98.82111],
              [38.11945, -98.82111],
              [38.11886, -98.8211],
              [38.11839, -98.8211],
              [38.11792, -98.8211],
              [38.11746, -98.82111],
              [38.11699, -98.82111],
              [38.11652, -98.82111],
              [38.11605, -98.8211],
              [38.11558, -98.8211],
              [38.11512, -98.82109],
              [38.11466, -98.82109],
              [38.1142, -98.82109],
              [38.11374, -98.82109],
              [38.11328, -98.82109],
              [38.11281, -98.82109],
              [38.11235, -98.82109],
              [38.11189, -98.82109],
              [38.11143, -98.82109],
              [38.11097, -98.82109],
              [38.11051, -98.8211],
              [38.11005, -98.8211],
              [38.10959, -98.8211],
              [38.10913, -98.8211],
              [38.10867, -98.8211],
              [38.10821, -98.8211],
              [38.10774, -98.8211],
              [38.10728, -98.8211],
              [38.10682, -98.8211],
              [38.10636, -98.8211],
              [38.1059, -98.8211],
              [38.10531, -98.8211],
              [38.10473, -98.8211],
              [38.10414, -98.8211],
              [38.10363, -98.82111],
              [38.10311, -98.82111],
              [38.1026, -98.82112],
              [38.10206, -98.82112],
              [38.10152, -98.82111],
              [38.10152, -98.82225],
              [38.10154, -98.8231],
              [38.10155, -98.82394],
              [38.10155, -98.82452],
              [38.10155, -98.82509],
              [38.10155, -98.82567],
              [38.10156, -98.82625],
              [38.10156, -98.82682],
              [38.10156, -98.8274],
              [38.10156, -98.82798],
              [38.10156, -98.82856],
              [38.10156, -98.82913],
              [38.10157, -98.82971],
              [38.10157, -98.83029],
              [38.10157, -98.83086],
              [38.10157, -98.83144]
            ],
            freeDraw: undefined
          },
          {
            points: [
              [38.10156, -98.82753],
              [38.10156, -98.82753],
              [38.10156, -98.82818],
              [38.10156, -98.82883],
              [38.10157, -98.82949],
              [38.10157, -98.83014],
              [38.10157, -98.83079],
              [38.10157, -98.83144]
            ],
            freeDraw: undefined
          },
          {
            points: [
              [38.10157, -98.83144],
              [38.10157, -98.83202],
              [38.10157, -98.83259],
              [38.10158, -98.83317],
              [38.10158, -98.83375],
              [38.10158, -98.83432],
              [38.10158, -98.8349],
              [38.10159, -98.83548],
              [38.10159, -98.83605],
              [38.10159, -98.83663],
              [38.10159, -98.8372],
              [38.10159, -98.83778],
              [38.1016, -98.83836],
              [38.1016, -98.83893],
              [38.1016, -98.83951],
              [38.10211, -98.83951],
              [38.10261, -98.83951],
              [38.10312, -98.83951],
              [38.10362, -98.83951],
              [38.10413, -98.83951],
              [38.10464, -98.83951],
              [38.10514, -98.83951],
              [38.10565, -98.83951]
            ],
            freeDraw: undefined
          }
        ],
        distance: 14617.499999999998,
        elevationGain: 28,
        estimatedTime: {
          value: '2.5–3',
          unit: 'hr'
        }
      },
      {
        id: 1,
        serverId: 53450256001,
        color: '#64f67b',
        elevationPoints: [
          [
            0,
            584,
            [38.17207, -98.80319],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            0,
            584,
            [38.17207, -98.80278],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            35.840941427137295,
            584,
            [38.17261, -98.80278],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            95.8862847533419,
            584,
            [38.17315, -98.80278],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            155.9316280795465,
            584,
            [38.17368, -98.80277],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            214.87150336018567,
            584,
            [38.17422, -98.80277],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            274.9168466863903,
            584,
            [38.1742, -98.80172],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            366.72886636085786,
            584,
            [38.17419, -98.80109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            421.8111513691165,
            584,
            [38.17419, -98.80047],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            476.0080716138309,
            584,
            [38.17419, -98.79984],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            531.0791357337366,
            584,
            [38.17418, -98.79921],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            586.1614282971368,
            584,
            [38.17416, -98.79895],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            608.9977200573303,
            584,
            [38.17418, -98.79872],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            629.2256565599855,
            584,
            [38.17422, -98.79853],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            646.4196354558189,
            584,
            [38.17428, -98.79844],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            656.7349576444994,
            584,
            [38.17436, -98.79834],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            669.2066973927595,
            584,
            [38.17447, -98.79825],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            683.7498239981214,
            584,
            [38.17465, -98.79815],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            705.5905378513744,
            583,
            [38.17464, -98.7977],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            744.942479723497,
            583,
            [38.17463, -98.79739],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            772.0635786658604,
            583,
            [38.1746, -98.79691],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            814.1546367374813,
            583,
            [38.17456, -98.79653],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            847.6683842756102,
            583,
            [38.1745, -98.79609],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            886.7048890996666,
            583,
            [38.17448, -98.79593],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            900.8668371101885,
            583,
            [38.17444, -98.7957],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            921.4581802708908,
            583,
            [38.17437, -98.79524],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            962.4151036688454,
            583,
            [38.17432, -98.79496],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            987.5145914606237,
            583,
            [38.17426, -98.79483],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1000.6921800340024,
            583,
            [38.17427, -98.79473],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1009.504048662282,
            583,
            [38.17422, -98.79459],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1022.9457610298723,
            583,
            [38.17417, -98.79426],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1052.3233990105819,
            583,
            [38.17415, -98.79393],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1081.2557560906316,
            583,
            [38.17414, -98.79345],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1123.229419275236,
            584,
            [38.17414, -98.79287],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1173.9297988062917,
            584,
            [38.17413, -98.79229],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1224.6423738915037,
            582,
            [38.17413, -98.79155],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1289.3290738912401,
            582,
            [38.17412, -98.79082],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1353.151320959123,
            582,
            [38.17412, -98.7901],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1416.0897404065345,
            582,
            [38.17411, -98.78938],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1479.0379859791701,
            582,
            [38.1741, -98.78873],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1535.8682834649626,
            582,
            [38.1741, -98.78807],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1593.5618504576814,
            582,
            [38.17409, -98.78717],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1672.2427594191176,
            582,
            [38.17408, -98.78641],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1738.6870945709088,
            582,
            [38.17406, -98.78565],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1805.1593503952663,
            582,
            [38.17405, -98.78489],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1871.6037128910702,
            582,
            [38.17404, -98.78416],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1935.4260299972502,
            582,
            [38.17403, -98.78342],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2000.1223707017107,
            581,
            [38.17402, -98.78269],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2063.9447053174426,
            581,
            [38.17402, -98.78195],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2128.631502955077,
            581,
            [38.17402, -98.7812],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2194.1924465057546,
            581,
            [38.17401, -98.78052],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2253.644772185058,
            581,
            [38.17401, -98.77984],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2313.086702494582,
            580,
            [38.174, -98.77916],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2372.5390363275965,
            580,
            [38.17399, -98.77848],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2431.9913783167776,
            580,
            [38.17399, -98.77788],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2484.4401547484977,
            580,
            [38.17399, -98.77728],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2536.8889311789735,
            580,
            [38.17399, -98.77668],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2589.3377076106935,
            580,
            [38.17398, -98.77617],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2633.933035618209,
            580,
            [38.17397, -98.77568],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2676.7806425636827,
            580,
            [38.17395, -98.77491],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2744.126662234068,
            579,
            [38.17394, -98.77419],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2807.0750545984574,
            579,
            [38.17395, -98.77376],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2844.6798110493273,
            579,
            [38.17395, -98.77302],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2909.3666708180117,
            579,
            [38.17394, -98.77229],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            2973.1890754718606,
            579,
            [38.17394, -98.77155],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3037.8759441165766,
            579,
            [38.17393, -98.77093],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3092.0844596282896,
            579,
            [38.17393, -98.77031],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3146.2815732283434,
            579,
            [38.17392, -98.76969],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3200.49009617515,
            579,
            [38.17391, -98.76906],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3255.572592726281,
            579,
            [38.17391, -98.76843],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3310.6438684321347,
            579,
            [38.1739, -98.76781],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3364.8524062491542,
            579,
            [38.1739, -98.76718],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3419.9236895116246,
            579,
            [38.17389, -98.76655],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3475.006201172908,
            579,
            [38.17324, -98.76654],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3547.2882893408114,
            579,
            [38.17277, -98.76653],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3599.557287366757,
            579,
            [38.1723, -98.76653],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3651.818975076514,
            579,
            [38.17183, -98.76652],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3704.08797329102,
            579,
            [38.17137, -98.76652],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3755.2377101980874,
            579,
            [38.1709, -98.76651],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3807.506708599145,
            578,
            [38.17043, -98.76651],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3859.768396308902,
            579,
            [38.16996, -98.7665],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3912.037394898516,
            579,
            [38.16949, -98.7665],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            3964.2990826082732,
            579,
            [38.16902, -98.76649],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4016.5680813864255,
            579,
            [38.16855, -98.76649],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4068.8297690961826,
            579,
            [38.16808, -98.76648],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4121.09876806291,
            578.3,
            [38.16762, -98.76648],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4172.24850497077,
            578.78,
            [38.16715, -98.76647],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4224.517504124042,
            579,
            [38.16668, -98.76647],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4276.779191833799,
            578,
            [38.16621, -98.76646],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4329.048191175623,
            578,
            [38.16575, -98.76646],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4380.197928082691,
            578,
            [38.16529, -98.76646],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4431.3476649905515,
            578.28,
            [38.16483, -98.76645],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4482.5048727390695,
            579,
            [38.16438, -98.76645],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4532.542658844241,
            578,
            [38.16392, -98.76645],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4583.692395752101,
            578,
            [38.16346, -98.76645],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4634.842132659169,
            578,
            [38.163, -98.76644],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4685.999340783541,
            579,
            [38.16254, -98.76644],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4737.1490776906085,
            579,
            [38.16254, -98.76586],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4787.857526210233,
            579,
            [38.16254, -98.76528],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4838.565974729858,
            578,
            [38.16253, -98.76462],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4896.279408807111,
            578.86,
            [38.16252, -98.76395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            4954.866974707342,
            579,
            [38.16251, -98.76329],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5012.580424609327,
            579,
            [38.16252, -98.7632],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5020.527159362386,
            579,
            [38.16257, -98.76308],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5032.400675667819,
            579,
            [38.16266, -98.76295],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5047.5443136312115,
            579,
            [38.16276, -98.76287],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5060.680638309024,
            579,
            [38.16293, -98.76276],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5081.889547054327,
            578.81,
            [38.16335, -98.76261],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5130.397808582684,
            578.91,
            [38.16367, -98.76242],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5169.666624403491,
            578.63,
            [38.16388, -98.76226],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5196.886841255831,
            578.63,
            [38.16388, -98.76226],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5196.886841255831,
            578.91,
            [38.16367, -98.76242],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5224.107058108171,
            578.81,
            [38.16335, -98.76261],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5263.375873928979,
            579,
            [38.16293, -98.76276],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5311.884135457336,
            579,
            [38.16276, -98.76287],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5333.093044202638,
            579,
            [38.16266, -98.76295],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5346.229368880451,
            579,
            [38.16257, -98.76308],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5361.3730068438435,
            579,
            [38.16252, -98.7632],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5373.246523149277,
            579,
            [38.16251, -98.76329],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5381.193257902336,
            578.86,
            [38.16252, -98.76395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5438.906707804321,
            578,
            [38.16253, -98.76462],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5497.494273704551,
            579,
            [38.16254, -98.76528],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5555.207707781805,
            579,
            [38.16254, -98.76586],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5605.9161563014295,
            579,
            [38.16254, -98.76644],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5656.624604821054,
            579,
            [38.16203, -98.76644],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5713.334095739983,
            579,
            [38.16151, -98.76643],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5771.162146984318,
            579,
            [38.161, -98.76643],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5827.871637903247,
            579,
            [38.16097, -98.76643],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5831.207490310522,
            579,
            [38.16045, -98.76643],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5889.028932032141,
            579,
            [38.15994, -98.76643],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            5945.73842295107,
            579,
            [38.15942, -98.76643],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6003.5598646726885,
            579,
            [38.15943, -98.76702],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6055.156783650533,
            579,
            [38.15944, -98.76761],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6106.753695555448,
            579,
            [38.15944, -98.76819],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6157.4643000911,
            579,
            [38.15945, -98.76878],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6209.061204923115,
            579,
            [38.15946, -98.76937],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6260.658102680971,
            579,
            [38.15947, -98.76996],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6312.254993367134,
            579,
            [38.15948, -98.77055],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6363.851876980394,
            579,
            [38.15948, -98.77113],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6414.56245369743,
            579.79,
            [38.15949, -98.77172],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6466.15933023775,
            580,
            [38.1595, -98.77231],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6517.756199705165,
            580,
            [38.15951, -98.7729],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6569.353062099637,
            580,
            [38.15952, -98.77349],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6620.949917419957,
            580,
            [38.15953, -98.77408],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6672.546765668574,
            581,
            [38.15953, -98.77466],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6723.257307612306,
            581,
            [38.15954, -98.77525],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6774.854148788008,
            582,
            [38.15955, -98.77584],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6826.450982890781,
            582,
            [38.15956, -98.77643],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6878.047809920603,
            582,
            [38.15957, -98.77702],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6929.644629876266,
            581,
            [38.15957, -98.7776],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            6980.355144002568,
            581.71,
            [38.15958, -98.77819],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7031.951956885276,
            582,
            [38.15959, -98.77878],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7083.548762696306,
            582,
            [38.1596, -98.77938],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7136.019680670999,
            583,
            [38.15961, -98.77999],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7189.364717112761,
            583,
            [38.15961, -98.78059],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7241.823840878516,
            584,
            [38.15962, -98.78119],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7294.294744466215,
            584,
            [38.15963, -98.78179],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7346.765640862292,
            584,
            [38.15964, -98.7824],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7400.110655365608,
            583,
            [38.15965, -98.783],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7452.581537375905,
            583,
            [38.15965, -98.7836],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7505.040632363673,
            583,
            [38.15966, -98.78421],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7558.385632241354,
            583,
            [38.15967, -98.78481],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7610.856499864638,
            583,
            [38.15967, -98.78542],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7664.189898473649,
            583.56,
            [38.15967, -98.78603],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7717.523297081416,
            583.56,
            [38.15967, -98.78664],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7770.856695690427,
            583,
            [38.15967, -98.78724],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7823.315776287947,
            583,
            [38.15967, -98.78785],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7876.649174896958,
            583,
            [38.15967, -98.78846],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7929.982573504725,
            582.46,
            [38.15968, -98.78907],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            7983.327558756764,
            583,
            [38.15968, -98.78968],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8036.6609500513605,
            583,
            [38.15968, -98.79029],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8089.994341344716,
            583,
            [38.15968, -98.79089],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8142.453414748978,
            584,
            [38.15968, -98.7915],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8195.786806042333,
            584,
            [38.15968, -98.79211],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8249.12019733569,
            584,
            [38.15968, -98.79272],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8302.453588630286,
            584,
            [38.15968, -98.79272],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8302.453588630286,
            584,
            [38.15968, -98.79411],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            8423.983775348132,
            583,
            [38.1705, -98.79425],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9627.176798767357,
            583,
            [38.17073, -98.79426],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9652.766603356597,
            583,
            [38.17109, -98.79431],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9693.034756181145,
            583,
            [38.17202, -98.79456],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9798.730247913956,
            583,
            [38.17251, -98.79468],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9854.216458974332,
            583.38,
            [38.17272, -98.79472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9877.82777451226,
            584,
            [38.17304, -98.79475],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9913.506709638967,
            583,
            [38.17353, -98.79477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9968.020341226866,
            583,
            [38.17378, -98.79477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            9995.81911128538,
            583,
            [38.17389, -98.79477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10008.050570111,
            583,
            [38.17415, -98.79478],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10036.974503310828,
            583,
            [38.17426, -98.79483],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10049.96341261807,
            583,
            [38.17432, -98.79496],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10063.141001191447,
            583,
            [38.17437, -98.79524],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10088.240488983227,
            583,
            [38.17444, -98.7957],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10129.19741238118,
            583,
            [38.17448, -98.79593],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10149.788755541884,
            583,
            [38.1745, -98.79609],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10163.950703552406,
            583,
            [38.17456, -98.79653],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10202.987208376462,
            583,
            [38.1746, -98.79691],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10236.50095591459,
            583,
            [38.17463, -98.79739],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10278.592013986208,
            583,
            [38.17464, -98.7977],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10305.713112928572,
            584,
            [38.17465, -98.79815],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10345.065054800694,
            584,
            [38.17447, -98.79825],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10366.905768653947,
            584,
            [38.17436, -98.79834],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10381.448895259307,
            584,
            [38.17428, -98.79844],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10393.920635007567,
            584,
            [38.17422, -98.79853],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10404.235957196246,
            584,
            [38.17418, -98.79872],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10421.42993609208,
            584,
            [38.17416, -98.79895],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10441.657872594735,
            584,
            [38.17418, -98.79921],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10464.494164354926,
            584,
            [38.1742, -98.80172],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10683.9155471978,
            584,
            [38.17422, -98.80277],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10775.727566872267,
            584,
            [38.17424, -98.80371],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10857.927135245873,
            584,
            [38.174, -98.80369],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10884.671159586249,
            584,
            [38.1734, -98.8037],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10951.393934186084,
            584,
            [38.1733, -98.8037],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10962.513442209807,
            584,
            [38.17304, -98.80375],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            10991.752688151662,
            584,
            [38.17275, -98.80378],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11024.10572324183,
            584,
            [38.17257, -98.80381],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11044.291912642288,
            584.62,
            [38.17198, -98.80388],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11110.181767799635,
            585,
            [38.17162, -98.8039],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11150.250158521541,
            584.22,
            [38.17123, -98.80391],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11193.625049783668,
            584,
            [38.17111, -98.80394],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11207.223737150316,
            584,
            [38.17092, -98.80395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11228.368880325923,
            584,
            [38.17088, -98.80395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11232.816683535884,
            584,
            [38.17064, -98.80395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11259.503502791713,
            584,
            [38.17036, -98.80399],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11290.833871355188,
            584,
            [38.17012, -98.80405],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11318.031258995508,
            584.82,
            [38.16997, -98.80415],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11336.862595257973,
            584.93,
            [38.16996, -98.80416],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11338.27703885731,
            585,
            [38.16981, -98.80428],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11357.98097612124,
            585,
            [38.16971, -98.80436],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11371.116940681432,
            585,
            [38.16962, -98.80444],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11383.326012524974,
            585,
            [38.16943, -98.80457],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11407.315738825846,
            584.01,
            [38.16926, -98.80463],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11426.933125084832,
            584,
            [38.16893, -98.80468],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11463.88692223613,
            584,
            [38.16872, -98.8047],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11487.303254418244,
            584,
            [38.16857, -98.80474],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11504.345134674879,
            584,
            [38.16821, -98.80484],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11545.318835244167,
            584,
            [38.16815, -98.80485],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11552.047572025667,
            584,
            [38.16806, -98.80496],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11565.926551468097,
            584.05,
            [38.16805, -98.80502],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11571.288422079515,
            584.04,
            [38.16804, -98.80507],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11575.798726271352,
            584,
            [38.16803, -98.80514],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11582.018453524981,
            584,
            [38.16802, -98.80518],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11585.687859915362,
            584,
            [38.16799, -98.80523],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11591.186436236761,
            584.14,
            [38.16795, -98.80526],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11596.349891950342,
            584.79,
            [38.16789, -98.80527],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11603.078629136022,
            585,
            [38.16784, -98.80525],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11608.906828279667,
            585,
            [38.16779, -98.80522],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11615.054121621399,
            585,
            [38.16779, -98.80523],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11615.928342256017,
            585,
            [38.16784, -98.80525],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11621.756541759822,
            584.79,
            [38.16789, -98.80527],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11627.584740903467,
            584.14,
            [38.16795, -98.80526],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11634.313478089147,
            584,
            [38.16799, -98.80523],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11639.476933802727,
            584,
            [38.16802, -98.80518],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11644.975510124126,
            584,
            [38.16803, -98.80514],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11648.644916514508,
            584.04,
            [38.16804, -98.80507],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11654.864643768136,
            584.05,
            [38.16805, -98.80502],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11659.374947959974,
            584,
            [38.16806, -98.80496],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11664.736818571391,
            584,
            [38.16815, -98.80485],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11678.615798013821,
            584,
            [38.16821, -98.80484],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11685.344534795322,
            584,
            [38.16857, -98.80474],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11726.31823536461,
            584,
            [38.16872, -98.8047],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11743.360115621244,
            584,
            [38.16893, -98.80468],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11766.776447803359,
            584.01,
            [38.16926, -98.80463],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11803.730244954657,
            585,
            [38.16943, -98.80457],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11823.347631213643,
            585,
            [38.16962, -98.80444],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11847.337357514514,
            585,
            [38.16971, -98.80436],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11859.546429358057,
            585,
            [38.16981, -98.80428],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11872.682393918249,
            584.93,
            [38.16996, -98.80416],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11892.386331182179,
            584.82,
            [38.16997, -98.80415],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11893.800774781515,
            584,
            [38.17012, -98.80405],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11912.63211104398,
            584,
            [38.17036, -98.80399],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11939.829498684301,
            584,
            [38.17064, -98.80395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11971.159867247776,
            584,
            [38.17088, -98.80395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            11997.846686503604,
            584,
            [38.17092, -98.80395],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12002.294489713566,
            584,
            [38.17111, -98.80394],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12023.439632889173,
            584.22,
            [38.17123, -98.80391],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12037.03832025582,
            585,
            [38.17162, -98.8039],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12080.413211517947,
            584.62,
            [38.17198, -98.80388],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12120.481602239854,
            584,
            [38.17257, -98.80381],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12186.371457397201,
            584,
            [38.17275, -98.80378],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12206.557646797659,
            584,
            [38.17304, -98.80375],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12238.910681887826,
            584,
            [38.1733, -98.8037],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12268.149927829681,
            584,
            [38.1734, -98.8037],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12279.269435853405,
            584,
            [38.174, -98.80369],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12345.99221045324,
            584,
            [38.17424, -98.80371],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12372.736234793616,
            584,
            [38.17422, -98.80277],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12454.935803167222,
            584,
            [38.1742, -98.80172],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12546.74782284169,
            584,
            [38.17419, -98.80109],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12601.830107849948,
            584,
            [38.17419, -98.80047],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12656.027028094662,
            584,
            [38.17419, -98.79984],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12711.09809221457,
            584,
            [38.17418, -98.79921],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12766.180384777968,
            584,
            [38.17416, -98.79895],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12789.01667653816,
            584,
            [38.17418, -98.79872],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12809.244613040815,
            584,
            [38.17422, -98.79853],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12826.438591936649,
            584,
            [38.17428, -98.79844],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12836.753914125327,
            584,
            [38.17436, -98.79834],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12849.225653873587,
            584,
            [38.17447, -98.79825],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12863.768780478948,
            584,
            [38.17465, -98.79815],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12885.6094943322,
            583,
            [38.17464, -98.7977],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12924.961436204323,
            583,
            [38.17463, -98.79739],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12952.082535146686,
            583,
            [38.1746, -98.79691],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            12994.173593218306,
            583,
            [38.17456, -98.79653],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13027.687340756433,
            583,
            [38.1745, -98.79609],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13066.723845580489,
            583,
            [38.17448, -98.79593],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13080.885793591011,
            583,
            [38.17444, -98.7957],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13101.477136751715,
            583,
            [38.17437, -98.79524],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13142.434060149668,
            583,
            [38.17432, -98.79496],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13167.533547941448,
            583,
            [38.17426, -98.79483],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13180.711136514825,
            583,
            [38.17415, -98.79478],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13193.700045822066,
            583,
            [38.17389, -98.79477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13222.623979021895,
            583,
            [38.17378, -98.79477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13234.855437847515,
            583,
            [38.17353, -98.79477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13262.65420790603,
            584,
            [38.17304, -98.79475],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13317.167839493928,
            583.38,
            [38.17272, -98.79472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13352.846774620635,
            583,
            [38.17251, -98.79468],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13376.458090158563,
            583,
            [38.17202, -98.79456],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13431.944301218939,
            583,
            [38.17156, -98.79444],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13484.158640197902,
            583,
            [38.17109, -98.79431],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13537.641644091427,
            583,
            [38.17073, -98.79426],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13577.909796915976,
            583,
            [38.1705, -98.79425],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13603.499601505215,
            583,
            [38.17005, -98.79424],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13653.545023352164,
            583,
            [38.1696, -98.79424],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13703.582809457335,
            583,
            [38.16915, -98.79423],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13753.62823149363,
            583,
            [38.1687, -98.79423],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13803.666017598802,
            583,
            [38.16825, -98.79422],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13853.711439823646,
            583,
            [38.1678, -98.79422],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13903.749225928817,
            583,
            [38.16734, -98.79421],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            13954.906433162925,
            583,
            [38.16689, -98.7942],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14004.951855672693,
            583,
            [38.16644, -98.7942],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14054.989641777864,
            583,
            [38.16599, -98.79419],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14105.03506447618,
            583,
            [38.16554, -98.79419],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14155.072850581351,
            583,
            [38.16509, -98.79418],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14205.118273468213,
            583,
            [38.16464, -98.79417],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14255.16369644935,
            583,
            [38.16419, -98.79417],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14305.201482554521,
            583,
            [38.16374, -98.79416],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14355.246905724178,
            583,
            [38.16329, -98.79416],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14405.28469182856,
            583,
            [38.16284, -98.79415],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14455.330115186784,
            584,
            [38.16239, -98.79415],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14505.367901291955,
            584,
            [38.16193, -98.79414],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14556.525109635613,
            583.98,
            [38.16148, -98.79413],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14606.570533278742,
            583,
            [38.16103, -98.79413],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14656.608319383913,
            584,
            [38.16058, -98.79412],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14706.653743214772,
            584,
            [38.16013, -98.79412],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14756.691529319944,
            584,
            [38.15968, -98.79411],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14806.736953340152,
            584,
            [38.15968, -98.79353],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14857.447390963736,
            584,
            [38.15968, -98.79295],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14908.15782858732,
            584,
            [38.15968, -98.79237],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            14958.868266210904,
            584,
            [38.15968, -98.79179],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15009.578703834488,
            583.98,
            [38.15968, -98.7912],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15061.16345934841,
            583,
            [38.15968, -98.79062],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15111.873896971994,
            583,
            [38.15968, -98.79004],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15162.584334595578,
            583,
            [38.15968, -98.78946],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15213.294772219162,
            582.56,
            [38.15967, -98.78888],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15264.01740297939,
            583,
            [38.15967, -98.7883],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15314.727847557662,
            583,
            [38.15967, -98.78772],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15365.438292137178,
            583,
            [38.15967, -98.78714],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15416.14873671545,
            583.56,
            [38.15967, -98.78655],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15467.733499302727,
            583.56,
            [38.15967, -98.78597],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15518.443943880999,
            583,
            [38.15967, -98.78539],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15569.15438845927,
            583,
            [38.15967, -98.78481],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15619.864833038786,
            583,
            [38.15946, -98.7848],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15643.232162517028,
            583,
            [38.15901, -98.7848],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15693.269948622199,
            582,
            [38.15856, -98.78479],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15743.315372877032,
            582,
            [38.1581, -98.78479],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15794.465109784893,
            582,
            [38.15765, -98.78478],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15844.510534230356,
            582,
            [38.1572, -98.78478],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15894.548320334738,
            582,
            [38.15675, -98.78478],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15944.586106439909,
            583.46,
            [38.1563, -98.78477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            15994.63153116817,
            584,
            [38.15584, -98.78477],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16045.78126807603,
            583,
            [38.15539, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16095.826692994897,
            582,
            [38.15494, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16145.864479099278,
            582,
            [38.15442, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16203.685920820897,
            582,
            [38.1539, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16261.507362542516,
            582,
            [38.15337, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16320.44075506603,
            582,
            [38.15285, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16378.26219678765,
            582.93,
            [38.15233, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16436.08363850927,
            583,
            [38.1521, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16461.6585069632,
            583,
            [38.15191, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16482.78557220716,
            583,
            [38.15108, -98.78476],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16575.077488801056,
            582,
            [38.1506, -98.78475],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16628.45828970529,
            582,
            [38.15012, -98.78474],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16681.839090702997,
            581,
            [38.14963, -98.78474],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16736.324680017337,
            581,
            [38.14915, -98.78473],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16789.70548120632,
            582,
            [38.14867, -98.78472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16843.08628248878,
            582,
            [38.14816, -98.78472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16899.7957734085,
            582,
            [38.14764, -98.78472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            16957.61721512933,
            582,
            [38.14713, -98.78472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17014.326706049047,
            582,
            [38.14661, -98.78472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17072.148147769876,
            582,
            [38.1461, -98.78472],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17128.857638689595,
            582.1,
            [38.14558, -98.78471],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17186.685692820967,
            582,
            [38.14507, -98.78469],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17243.422147515936,
            582,
            [38.14448, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17309.050554274996,
            582,
            [38.14403, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17359.088340380164,
            581,
            [38.14357, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17410.238077288028,
            581,
            [38.14312, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17460.27586339241,
            581,
            [38.14266, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17511.425600300267,
            582,
            [38.14221, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17561.46338640544,
            581.01,
            [38.14176, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17611.50117251061,
            581,
            [38.1413, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17662.65090941768,
            582,
            [38.14085, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17712.688695522847,
            581,
            [38.1404, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17762.726481628022,
            581,
            [38.13994, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17813.876218535086,
            582.56,
            [38.13949, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17863.91400464026,
            582,
            [38.13903, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17915.063741548118,
            583,
            [38.13858, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            17965.101527653293,
            583.56,
            [38.13813, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18015.13931375846,
            582.93,
            [38.13767, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18066.28905066553,
            581,
            [38.13722, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18116.3268367707,
            581,
            [38.13676, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18167.47657367777,
            582,
            [38.13631, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18217.514359782937,
            582,
            [38.13631, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18217.514359782937,
            581,
            [38.13676, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18267.552145888105,
            581,
            [38.13722, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18318.701882795176,
            582.93,
            [38.13767, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18368.739668900344,
            583.56,
            [38.13813, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18419.889405807415,
            583,
            [38.13858, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18469.927191912582,
            582,
            [38.13903, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18519.96497801775,
            582.56,
            [38.13949, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18571.114714925607,
            581,
            [38.13994, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18621.152501030774,
            581,
            [38.1404, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18672.302237937845,
            582,
            [38.14085, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18722.340024043013,
            581,
            [38.1413, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18772.37781014818,
            581.01,
            [38.14176, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18823.52754705525,
            582,
            [38.14221, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18873.56533316042,
            581,
            [38.14266, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18923.603119265586,
            581,
            [38.14312, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            18974.752856173443,
            581,
            [38.14357, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19024.790642277825,
            582,
            [38.14403, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19075.940379185682,
            582,
            [38.14448, -98.78467],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19125.97816529085,
            582,
            [38.14507, -98.78469],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19191.60657204991,
            582,
            [38.14507, -98.78532],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19246.69963406329,
            582,
            [38.14508, -98.78596],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19302.67823019417,
            582,
            [38.14508, -98.78659],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19357.77128465577,
            582,
            [38.14508, -98.78722],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19412.86433911737,
            583,
            [38.1451, -98.7879],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19472.37142046733,
            583,
            [38.14511, -98.78868],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19540.590908256352,
            583,
            [38.14511, -98.78939],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19602.679880609117,
            582,
            [38.1451, -98.7901],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19664.778813376382,
            582,
            [38.1451, -98.79081],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19726.867794239894,
            582,
            [38.1451, -98.79143],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19781.086340910675,
            582,
            [38.14511, -98.79204],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19834.441979222538,
            581.05,
            [38.14511, -98.79266],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19888.660518460165,
            581,
            [38.14511, -98.79328],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19942.87905769779,
            581,
            [38.14511, -98.7939],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            19997.09759693542,
            582,
            [38.14512, -98.79451],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20050.453227938044,
            582.4,
            [38.14512, -98.79513],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20104.671759743753,
            583,
            [38.14512, -98.79584],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20166.76072358578,
            582,
            [38.14512, -98.79656],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20229.72417987656,
            583.52,
            [38.14512, -98.79727],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20291.813143718588,
            584,
            [38.14512, -98.79798],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20353.902107560614,
            583,
            [38.14512, -98.79857],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20405.497162021296,
            583,
            [38.14512, -98.79917],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20457.966708930733,
            583,
            [38.14512, -98.79976],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20509.561763391415,
            584,
            [38.14513, -98.80035],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20561.168795028236,
            584,
            [38.14513, -98.80094],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20612.763842416607,
            584,
            [38.14513, -98.80154],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20665.23338213387,
            585,
            [38.14513, -98.80213],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20716.82842952224,
            585,
            [38.14513, -98.80261],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20758.804061295326,
            585,
            [38.14568, -98.80261],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20819.96135542343,
            585,
            [38.14623, -98.80262],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20881.124901304167,
            585,
            [38.14678, -98.80262],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            20942.28219543227,
            584,
            [38.14732, -98.80263],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21002.333906080174,
            584,
            [38.14786, -98.80264],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21062.385616633837,
            585,
            [38.1484, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21122.437327093234,
            585,
            [38.14866, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21151.348047953645,
            585,
            [38.14897, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21185.818522825917,
            585,
            [38.14949, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21243.639964547532,
            584,
            [38.15001, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21301.461406269147,
            584,
            [38.15053, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21359.282847990762,
            584.96,
            [38.15073, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21381.521864037415,
            585,
            [38.15123, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21437.11940415366,
            585,
            [38.15172, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21491.604993468005,
            585,
            [38.15222, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21547.202533585034,
            585,
            [38.15268, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21598.352270492105,
            585,
            [38.15313, -98.80264],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21648.397695978674,
            585,
            [38.15361, -98.80264],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21701.771334491117,
            585,
            [38.15408, -98.80264],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21754.033022200878,
            585,
            [38.15456, -98.80264],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21807.406660712535,
            585,
            [38.15504, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21860.787460839085,
            585,
            [38.15552, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21914.161099351528,
            585,
            [38.15599, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            21966.42278706129,
            585,
            [38.15647, -98.80265],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22019.796425572946,
            585,
            [38.15695, -98.80266],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22073.17722532439,
            585,
            [38.15744, -98.80266],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22127.662814638737,
            585,
            [38.15792, -98.80267],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22181.04361419889,
            585,
            [38.1584, -98.80267],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22234.417252711333,
            584,
            [38.15902, -98.80268],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22303.363746485782,
            585,
            [38.15964, -98.80268],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22372.30469623112,
            584,
            [38.16015, -98.80268],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22429.014187150053,
            584.96,
            [38.16067, -98.80269],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22486.842238640944,
            586.71,
            [38.16118, -98.80269],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22543.551729559877,
            586,
            [38.16169, -98.80269],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22600.26122047881,
            586.95,
            [38.16203, -98.80269],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22638.067547758357,
            587,
            [38.16221, -98.80268],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22658.101748185152,
            585.85,
            [38.16286, -98.80267],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22730.383837952962,
            585,
            [38.16335, -98.80268],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22784.876441147222,
            585,
            [38.16384, -98.80268],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22839.36203046157,
            585,
            [38.16432, -98.80269],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22892.74282876477,
            584,
            [38.16481, -98.8027],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            22947.235431678942,
            584,
            [38.1653, -98.8027],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23001.72102099329,
            585,
            [38.16579, -98.80271],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23056.213623718126,
            585,
            [38.16628, -98.80271],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23110.699213032472,
            585,
            [38.16677, -98.80272],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23165.19181556873,
            584,
            [38.16725, -98.80273],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23218.57261329725,
            584,
            [38.16774, -98.80273],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23273.058202611595,
            584,
            [38.16823, -98.80274],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23327.550804866973,
            584,
            [38.16874, -98.80275],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23384.267033650547,
            584,
            [38.16924, -98.80276],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23439.8714462778,
            584,
            [38.16975, -98.80277],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23496.587674874645,
            584,
            [38.17026, -98.80277],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23553.297165793578,
            583.98,
            [38.17076, -98.80278],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23608.901578134224,
            584,
            [38.17127, -98.80279],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23665.6178064501,
            584,
            [38.17207, -98.80278],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            23754.57816580151,
            584,
            [38.17207, -98.80319],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ]
        ],
        paths: [
          {
            points: [
              [38.17207, -98.80319],
              [38.17207, -98.80278],
              [38.17261, -98.80278],
              [38.17315, -98.80278],
              [38.17368, -98.80277],
              [38.17422, -98.80277],
              [38.1742, -98.80172],
              [38.17419, -98.80109],
              [38.17419, -98.80047],
              [38.17419, -98.79984],
              [38.17418, -98.79921],
              [38.17416, -98.79895],
              [38.17418, -98.79872],
              [38.17422, -98.79853],
              [38.17428, -98.79844],
              [38.17436, -98.79834],
              [38.17447, -98.79825],
              [38.17465, -98.79815],
              [38.17464, -98.7977],
              [38.17463, -98.79739],
              [38.1746, -98.79691],
              [38.17456, -98.79653],
              [38.1745, -98.79609],
              [38.17448, -98.79593],
              [38.17444, -98.7957],
              [38.17437, -98.79524],
              [38.17432, -98.79496],
              [38.17426, -98.79483],
              [38.17427, -98.79473],
              [38.17422, -98.79459],
              [38.17417, -98.79426],
              [38.17415, -98.79393],
              [38.17414, -98.79345],
              [38.17414, -98.79287],
              [38.17413, -98.79229],
              [38.17413, -98.79155],
              [38.17412, -98.79082],
              [38.17412, -98.7901],
              [38.17411, -98.78938],
              [38.1741, -98.78873],
              [38.1741, -98.78807],
              [38.17409, -98.78717],
              [38.17408, -98.78641],
              [38.17406, -98.78565],
              [38.17405, -98.78489],
              [38.17404, -98.78416],
              [38.17403, -98.78342],
              [38.17402, -98.78269],
              [38.17402, -98.78195],
              [38.17402, -98.7812],
              [38.17401, -98.78052],
              [38.17401, -98.77984],
              [38.174, -98.77916],
              [38.17399, -98.77848],
              [38.17399, -98.77788],
              [38.17399, -98.77728],
              [38.17399, -98.77668],
              [38.17398, -98.77617],
              [38.17397, -98.77568],
              [38.17395, -98.77491],
              [38.17394, -98.77419],
              [38.17395, -98.77376],
              [38.17395, -98.77302],
              [38.17394, -98.77229],
              [38.17394, -98.77155],
              [38.17393, -98.77093],
              [38.17393, -98.77031],
              [38.17392, -98.76969],
              [38.17391, -98.76906],
              [38.17391, -98.76843],
              [38.1739, -98.76781],
              [38.1739, -98.76718],
              [38.17389, -98.76655],
              [38.17324, -98.76654],
              [38.17277, -98.76653],
              [38.1723, -98.76653],
              [38.17183, -98.76652],
              [38.17137, -98.76652],
              [38.1709, -98.76651],
              [38.17043, -98.76651],
              [38.16996, -98.7665],
              [38.16949, -98.7665],
              [38.16902, -98.76649],
              [38.16855, -98.76649],
              [38.16808, -98.76648],
              [38.16762, -98.76648],
              [38.16715, -98.76647],
              [38.16668, -98.76647],
              [38.16621, -98.76646],
              [38.16575, -98.76646],
              [38.16529, -98.76646],
              [38.16483, -98.76645],
              [38.16438, -98.76645],
              [38.16392, -98.76645],
              [38.16346, -98.76645],
              [38.163, -98.76644],
              [38.16254, -98.76644],
              [38.16254, -98.76586],
              [38.16254, -98.76528],
              [38.16253, -98.76462],
              [38.16252, -98.76395],
              [38.16251, -98.76329],
              [38.16252, -98.7632],
              [38.16257, -98.76308],
              [38.16266, -98.76295],
              [38.16276, -98.76287],
              [38.16293, -98.76276],
              [38.16335, -98.76261],
              [38.16367, -98.76242],
              [38.16388, -98.76226],
              [38.16388, -98.76226],
              [38.16367, -98.76242],
              [38.16335, -98.76261],
              [38.16293, -98.76276],
              [38.16276, -98.76287],
              [38.16266, -98.76295],
              [38.16257, -98.76308],
              [38.16252, -98.7632],
              [38.16251, -98.76329],
              [38.16252, -98.76395],
              [38.16253, -98.76462],
              [38.16254, -98.76528],
              [38.16254, -98.76586],
              [38.16254, -98.76644],
              [38.16203, -98.76644],
              [38.16151, -98.76643],
              [38.161, -98.76643],
              [38.16097, -98.76643],
              [38.16045, -98.76643],
              [38.15994, -98.76643],
              [38.15942, -98.76643],
              [38.15943, -98.76702],
              [38.15944, -98.76761],
              [38.15944, -98.76819],
              [38.15945, -98.76878],
              [38.15946, -98.76937],
              [38.15947, -98.76996],
              [38.15948, -98.77055],
              [38.15948, -98.77113],
              [38.15949, -98.77172],
              [38.1595, -98.77231],
              [38.15951, -98.7729],
              [38.15952, -98.77349],
              [38.15953, -98.77408],
              [38.15953, -98.77466],
              [38.15954, -98.77525],
              [38.15955, -98.77584],
              [38.15956, -98.77643],
              [38.15957, -98.77702],
              [38.15957, -98.7776],
              [38.15958, -98.77819],
              [38.15959, -98.77878],
              [38.1596, -98.77938],
              [38.15961, -98.77999],
              [38.15961, -98.78059],
              [38.15962, -98.78119],
              [38.15963, -98.78179],
              [38.15964, -98.7824],
              [38.15965, -98.783],
              [38.15965, -98.7836],
              [38.15966, -98.78421],
              [38.15967, -98.78481],
              [38.15967, -98.78542],
              [38.15967, -98.78603],
              [38.15967, -98.78664],
              [38.15967, -98.78724],
              [38.15967, -98.78785],
              [38.15967, -98.78846],
              [38.15968, -98.78907],
              [38.15968, -98.78968],
              [38.15968, -98.79029],
              [38.15968, -98.79089],
              [38.15968, -98.7915],
              [38.15968, -98.79211],
              [38.15968, -98.79272],
              [38.15968, -98.79272],
              [38.15968, -98.79411],
              [38.1705, -98.79425],
              [38.17073, -98.79426],
              [38.17109, -98.79431],
              [38.17202, -98.79456],
              [38.17251, -98.79468],
              [38.17272, -98.79472],
              [38.17304, -98.79475],
              [38.17353, -98.79477],
              [38.17378, -98.79477],
              [38.17389, -98.79477],
              [38.17415, -98.79478],
              [38.17426, -98.79483],
              [38.17432, -98.79496],
              [38.17437, -98.79524],
              [38.17444, -98.7957],
              [38.17448, -98.79593],
              [38.1745, -98.79609],
              [38.17456, -98.79653],
              [38.1746, -98.79691],
              [38.17463, -98.79739],
              [38.17464, -98.7977],
              [38.17465, -98.79815],
              [38.17447, -98.79825],
              [38.17436, -98.79834],
              [38.17428, -98.79844],
              [38.17422, -98.79853],
              [38.17418, -98.79872],
              [38.17416, -98.79895],
              [38.17418, -98.79921],
              [38.1742, -98.80172],
              [38.17422, -98.80277],
              [38.17424, -98.80371],
              [38.174, -98.80369],
              [38.1734, -98.8037],
              [38.1733, -98.8037],
              [38.17304, -98.80375],
              [38.17275, -98.80378],
              [38.17257, -98.80381],
              [38.17198, -98.80388],
              [38.17162, -98.8039],
              [38.17123, -98.80391],
              [38.17111, -98.80394],
              [38.17092, -98.80395],
              [38.17088, -98.80395],
              [38.17064, -98.80395],
              [38.17036, -98.80399],
              [38.17012, -98.80405],
              [38.16997, -98.80415],
              [38.16996, -98.80416],
              [38.16981, -98.80428],
              [38.16971, -98.80436],
              [38.16962, -98.80444],
              [38.16943, -98.80457],
              [38.16926, -98.80463],
              [38.16893, -98.80468],
              [38.16872, -98.8047],
              [38.16857, -98.80474],
              [38.16821, -98.80484],
              [38.16815, -98.80485],
              [38.16806, -98.80496],
              [38.16805, -98.80502],
              [38.16804, -98.80507],
              [38.16803, -98.80514],
              [38.16802, -98.80518],
              [38.16799, -98.80523],
              [38.16795, -98.80526],
              [38.16789, -98.80527],
              [38.16784, -98.80525],
              [38.16779, -98.80522],
              [38.16779, -98.80523],
              [38.16784, -98.80525],
              [38.16789, -98.80527],
              [38.16795, -98.80526],
              [38.16799, -98.80523],
              [38.16802, -98.80518],
              [38.16803, -98.80514],
              [38.16804, -98.80507],
              [38.16805, -98.80502],
              [38.16806, -98.80496],
              [38.16815, -98.80485],
              [38.16821, -98.80484],
              [38.16857, -98.80474],
              [38.16872, -98.8047],
              [38.16893, -98.80468],
              [38.16926, -98.80463],
              [38.16943, -98.80457],
              [38.16962, -98.80444],
              [38.16971, -98.80436],
              [38.16981, -98.80428],
              [38.16996, -98.80416],
              [38.16997, -98.80415],
              [38.17012, -98.80405],
              [38.17036, -98.80399],
              [38.17064, -98.80395],
              [38.17088, -98.80395],
              [38.17092, -98.80395],
              [38.17111, -98.80394],
              [38.17123, -98.80391],
              [38.17162, -98.8039],
              [38.17198, -98.80388],
              [38.17257, -98.80381],
              [38.17275, -98.80378],
              [38.17304, -98.80375],
              [38.1733, -98.8037],
              [38.1734, -98.8037],
              [38.174, -98.80369],
              [38.17424, -98.80371],
              [38.17422, -98.80277],
              [38.1742, -98.80172],
              [38.17419, -98.80109],
              [38.17419, -98.80047],
              [38.17419, -98.79984],
              [38.17418, -98.79921],
              [38.17416, -98.79895],
              [38.17418, -98.79872],
              [38.17422, -98.79853],
              [38.17428, -98.79844],
              [38.17436, -98.79834],
              [38.17447, -98.79825],
              [38.17465, -98.79815],
              [38.17464, -98.7977],
              [38.17463, -98.79739],
              [38.1746, -98.79691],
              [38.17456, -98.79653],
              [38.1745, -98.79609],
              [38.17448, -98.79593],
              [38.17444, -98.7957],
              [38.17437, -98.79524],
              [38.17432, -98.79496],
              [38.17426, -98.79483],
              [38.17415, -98.79478],
              [38.17389, -98.79477],
              [38.17378, -98.79477],
              [38.17353, -98.79477],
              [38.17304, -98.79475],
              [38.17272, -98.79472],
              [38.17251, -98.79468],
              [38.17202, -98.79456],
              [38.17156, -98.79444],
              [38.17109, -98.79431],
              [38.17073, -98.79426],
              [38.1705, -98.79425],
              [38.17005, -98.79424],
              [38.1696, -98.79424],
              [38.16915, -98.79423],
              [38.1687, -98.79423],
              [38.16825, -98.79422],
              [38.1678, -98.79422],
              [38.16734, -98.79421],
              [38.16689, -98.7942],
              [38.16644, -98.7942],
              [38.16599, -98.79419],
              [38.16554, -98.79419],
              [38.16509, -98.79418],
              [38.16464, -98.79417],
              [38.16419, -98.79417],
              [38.16374, -98.79416],
              [38.16329, -98.79416],
              [38.16284, -98.79415],
              [38.16239, -98.79415],
              [38.16193, -98.79414],
              [38.16148, -98.79413],
              [38.16103, -98.79413],
              [38.16058, -98.79412],
              [38.16013, -98.79412],
              [38.15968, -98.79411],
              [38.15968, -98.79353],
              [38.15968, -98.79295],
              [38.15968, -98.79237],
              [38.15968, -98.79179],
              [38.15968, -98.7912],
              [38.15968, -98.79062],
              [38.15968, -98.79004],
              [38.15968, -98.78946],
              [38.15967, -98.78888],
              [38.15967, -98.7883],
              [38.15967, -98.78772],
              [38.15967, -98.78714],
              [38.15967, -98.78655],
              [38.15967, -98.78597],
              [38.15967, -98.78539],
              [38.15967, -98.78481],
              [38.15946, -98.7848],
              [38.15901, -98.7848],
              [38.15856, -98.78479],
              [38.1581, -98.78479],
              [38.15765, -98.78478],
              [38.1572, -98.78478],
              [38.15675, -98.78478],
              [38.1563, -98.78477],
              [38.15584, -98.78477],
              [38.15539, -98.78476],
              [38.15494, -98.78476],
              [38.15442, -98.78476],
              [38.1539, -98.78476],
              [38.15337, -98.78476],
              [38.15285, -98.78476],
              [38.15233, -98.78476],
              [38.1521, -98.78476],
              [38.15191, -98.78476],
              [38.15108, -98.78476],
              [38.1506, -98.78475],
              [38.15012, -98.78474],
              [38.14963, -98.78474],
              [38.14915, -98.78473],
              [38.14867, -98.78472],
              [38.14816, -98.78472],
              [38.14764, -98.78472],
              [38.14713, -98.78472],
              [38.14661, -98.78472],
              [38.1461, -98.78472],
              [38.14558, -98.78471],
              [38.14507, -98.78469],
              [38.14448, -98.78467],
              [38.14403, -98.78467],
              [38.14357, -98.78467],
              [38.14312, -98.78467],
              [38.14266, -98.78467],
              [38.14221, -98.78467],
              [38.14176, -98.78467],
              [38.1413, -98.78467],
              [38.14085, -98.78467],
              [38.1404, -98.78467],
              [38.13994, -98.78467],
              [38.13949, -98.78467],
              [38.13903, -98.78467],
              [38.13858, -98.78467],
              [38.13813, -98.78467],
              [38.13767, -98.78467],
              [38.13722, -98.78467],
              [38.13676, -98.78467],
              [38.13631, -98.78467],
              [38.13631, -98.78467],
              [38.13676, -98.78467],
              [38.13722, -98.78467],
              [38.13767, -98.78467],
              [38.13813, -98.78467],
              [38.13858, -98.78467],
              [38.13903, -98.78467],
              [38.13949, -98.78467],
              [38.13994, -98.78467],
              [38.1404, -98.78467],
              [38.14085, -98.78467],
              [38.1413, -98.78467],
              [38.14176, -98.78467],
              [38.14221, -98.78467],
              [38.14266, -98.78467],
              [38.14312, -98.78467],
              [38.14357, -98.78467],
              [38.14403, -98.78467],
              [38.14448, -98.78467],
              [38.14507, -98.78469],
              [38.14507, -98.78532],
              [38.14508, -98.78596],
              [38.14508, -98.78659],
              [38.14508, -98.78722],
              [38.1451, -98.7879],
              [38.14511, -98.78868],
              [38.14511, -98.78939],
              [38.1451, -98.7901],
              [38.1451, -98.79081],
              [38.1451, -98.79143],
              [38.14511, -98.79204],
              [38.14511, -98.79266],
              [38.14511, -98.79328],
              [38.14511, -98.7939],
              [38.14512, -98.79451],
              [38.14512, -98.79513],
              [38.14512, -98.79584],
              [38.14512, -98.79656],
              [38.14512, -98.79727],
              [38.14512, -98.79798],
              [38.14512, -98.79857],
              [38.14512, -98.79917],
              [38.14512, -98.79976],
              [38.14513, -98.80035],
              [38.14513, -98.80094],
              [38.14513, -98.80154],
              [38.14513, -98.80213],
              [38.14513, -98.80261],
              [38.14568, -98.80261],
              [38.14623, -98.80262],
              [38.14678, -98.80262],
              [38.14732, -98.80263],
              [38.14786, -98.80264],
              [38.1484, -98.80265],
              [38.14866, -98.80265],
              [38.14897, -98.80265],
              [38.14949, -98.80265],
              [38.15001, -98.80265],
              [38.15053, -98.80265],
              [38.15073, -98.80265],
              [38.15123, -98.80265],
              [38.15172, -98.80265],
              [38.15222, -98.80265],
              [38.15268, -98.80265],
              [38.15313, -98.80264],
              [38.15361, -98.80264],
              [38.15408, -98.80264],
              [38.15456, -98.80264],
              [38.15504, -98.80265],
              [38.15552, -98.80265],
              [38.15599, -98.80265],
              [38.15647, -98.80265],
              [38.15695, -98.80266],
              [38.15744, -98.80266],
              [38.15792, -98.80267],
              [38.1584, -98.80267],
              [38.15902, -98.80268],
              [38.15964, -98.80268],
              [38.16015, -98.80268],
              [38.16067, -98.80269],
              [38.16118, -98.80269],
              [38.16169, -98.80269],
              [38.16203, -98.80269],
              [38.16221, -98.80268],
              [38.16286, -98.80267],
              [38.16335, -98.80268],
              [38.16384, -98.80268],
              [38.16432, -98.80269],
              [38.16481, -98.8027],
              [38.1653, -98.8027],
              [38.16579, -98.80271],
              [38.16628, -98.80271],
              [38.16677, -98.80272],
              [38.16725, -98.80273],
              [38.16774, -98.80273],
              [38.16823, -98.80274],
              [38.16874, -98.80275],
              [38.16924, -98.80276],
              [38.16975, -98.80277],
              [38.17026, -98.80277],
              [38.17076, -98.80278],
              [38.17127, -98.80279],
              [38.17207, -98.80278],
              [38.17207, -98.80319]
            ],
            freeDraw: undefined
          }
        ],
        distance: 23791.56,
        elevationGain: 33,
        estimatedTime: {
          value: '4.5–5',
          unit: 'hr'
        }
      },
      {
        id: 2,
        serverId: 53450256002,
        color: '#eea82f',
        elevationPoints: [
          [
            0,
            591,
            [38.13423, -98.84644],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            0,
            591,
            [38.13378, -98.84645],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            50.045429445301124,
            591,
            [38.13333, -98.84645],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            100.0832155504686,
            591,
            [38.13287, -98.84646],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            151.24042984884727,
            591,
            [38.13242, -98.84647],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            201.2858595781945,
            590,
            [38.13197, -98.84647],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            251.32364568336197,
            590,
            [38.13152, -98.84648],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            301.36907560199325,
            591,
            [38.13106, -98.84648],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            352.51881250985025,
            591,
            [38.13061, -98.84649],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            402.56424261906795,
            591,
            [38.1306, -98.84604],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            441.93993473483715,
            591,
            [38.1306, -98.84541],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            497.0439224146103,
            590,
            [38.1306, -98.84478],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            552.1479100943834,
            590,
            [38.1306, -98.84415],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            607.2518977741565,
            590,
            [38.13061, -98.84352],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            662.3670996407891,
            589,
            [38.13061, -98.84289],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            717.4710797712178,
            590,
            [38.13061, -98.84226],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            772.5750599016465,
            591,
            [38.13061, -98.84163],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            827.6790400320751,
            591,
            [38.1306, -98.84092],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            889.7903094076974,
            590,
            [38.13059, -98.84022],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            951.0270629379665,
            589,
            [38.13058, -98.83951],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1013.1383493268586,
            589,
            [38.13059, -98.83884],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1071.751563287864,
            589,
            [38.13059, -98.83826],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1122.4822255621766,
            588,
            [38.13059, -98.83769],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1172.3382212465149,
            588,
            [38.13058, -98.83711],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1223.0810717967543,
            588,
            [38.13058, -98.83654],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1272.9370743102118,
            588,
            [38.13058, -98.83596],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1323.6677435347156,
            589,
            [38.13058, -98.83538],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1374.3984127592194,
            589.74,
            [38.13058, -98.83481],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1424.2544152726769,
            589,
            [38.13057, -98.83423],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1474.9972727714558,
            588,
            [38.13057, -98.83366],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1524.8532821165209,
            588,
            [38.13057, -98.83308],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1575.5839582912158,
            588,
            [38.13057, -98.8325],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1626.3146344659108,
            588,
            [38.13057, -98.83193],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1676.1706438097317,
            588,
            [38.13056, -98.83135],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1726.9135082570137,
            588,
            [38.13056, -98.83078],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1776.7695244311908,
            588,
            [38.13056, -98.8302],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1827.500207556077,
            588,
            [38.13056, -98.83014],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ]
        ],
        paths: [
          {
            points: [
              [38.13423, -98.84644],
              [38.13378, -98.84645],
              [38.13333, -98.84645],
              [38.13287, -98.84646],
              [38.13242, -98.84647],
              [38.13197, -98.84647],
              [38.13152, -98.84648],
              [38.13106, -98.84648],
              [38.13061, -98.84649],
              [38.1306, -98.84604],
              [38.1306, -98.84541],
              [38.1306, -98.84478],
              [38.1306, -98.84415],
              [38.13061, -98.84352],
              [38.13061, -98.84289],
              [38.13061, -98.84226],
              [38.13061, -98.84163],
              [38.1306, -98.84092],
              [38.13059, -98.84022],
              [38.13058, -98.83951],
              [38.13059, -98.83884],
              [38.13059, -98.83826],
              [38.13059, -98.83769],
              [38.13058, -98.83711],
              [38.13058, -98.83654],
              [38.13058, -98.83596],
              [38.13058, -98.83538],
              [38.13058, -98.83481],
              [38.13057, -98.83423],
              [38.13057, -98.83366],
              [38.13057, -98.83308],
              [38.13057, -98.8325],
              [38.13057, -98.83193],
              [38.13056, -98.83135],
              [38.13056, -98.83078],
              [38.13056, -98.8302],
              [38.13056, -98.83014]
            ],
            freeDraw: undefined
          }
        ],
        distance: 1835.47,
        elevationGain: 3,
        estimatedTime: {
          value: '0.5–1',
          unit: 'hr'
        }
      },
      {
        id: 3,
        serverId: 53450256003,
        color: '#a57ed8',
        elevationPoints: [
          [
            0,
            591,
            [38.17332, -98.86778],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            0,
            591,
            [38.17386, -98.86778],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            60.04534332620824,
            591,
            [38.17439, -98.86777],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            118.98521848133532,
            591,
            [38.17439, -98.86709],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            178.42683884635335,
            591,
            [38.17439, -98.8664],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            238.7426006888636,
            591,
            [38.17439, -98.86572],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            298.1842210551258,
            591,
            [38.17439, -98.86503],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            358.4999828963919,
            591,
            [38.1744, -98.86443],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            410.9602536660168,
            591,
            [38.17441, -98.86383],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            463.4205172404254,
            591,
            [38.17443, -98.86323],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            515.9161115844472,
            591,
            [38.17444, -98.86263],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            568.376353573105,
            591,
            [38.17445, -98.86203],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            620.836588365295,
            591,
            [38.17446, -98.86137],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            678.5405889125468,
            591,
            [38.17447, -98.86071],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            736.2445815434548,
            591,
            [38.17448, -98.86005],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            793.9485662592997,
            591,
            [38.17449, -98.85934],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            856.022490319272,
            591,
            [38.17449, -98.85863],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            918.0864499501404,
            591,
            [38.1745, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            980.160365496442,
            591,
            [38.1743, -98.85793],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1002.4165546993172,
            591,
            [38.17416, -98.85794],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1018.0083892834082,
            592,
            [38.17415, -98.85728],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1075.7126272810929,
            591,
            [38.17416, -98.85669],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1127.2991261538118,
            591,
            [38.17417, -98.85609],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1179.759562413521,
            591,
            [38.17418, -98.8555],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1231.3460471345388,
            591,
            [38.17419, -98.8549],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1283.806469003859,
            591,
            [38.1742, -98.85431],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1335.3929395756422,
            591,
            [38.17421, -98.85371],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1387.8533470533002,
            591,
            [38.17422, -98.85312],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1439.4398034746118,
            591,
            [38.17424, -98.85252],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1491.9355344371725,
            591,
            [38.17425, -98.85193],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1543.521969632784,
            591,
            [38.17426, -98.85133],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1595.9823411343605,
            591,
            [38.17427, -98.85074],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1647.5687621794932,
            591,
            [38.17428, -98.85014],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1700.0291192918958,
            591,
            [38.17429, -98.84955],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1751.6155261865206,
            591,
            [38.1743, -98.84895],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1804.075868907239,
            591,
            [38.17431, -98.84836],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1855.6622616513632,
            591,
            [38.17432, -98.84761],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1921.2323688377073,
            591,
            [38.17432, -98.84685],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ]
        ],
        paths: [
          {
            points: [
              [38.17332, -98.86778],
              [38.17386, -98.86778],
              [38.17439, -98.86777],
              [38.17439, -98.86709],
              [38.17439, -98.8664],
              [38.17439, -98.86572],
              [38.17439, -98.86503],
              [38.1744, -98.86443],
              [38.17441, -98.86383],
              [38.17443, -98.86323],
              [38.17444, -98.86263],
              [38.17445, -98.86203],
              [38.17446, -98.86137],
              [38.17447, -98.86071],
              [38.17448, -98.86005],
              [38.17449, -98.85934],
              [38.17449, -98.85863],
              [38.1745, -98.85792],
              [38.1743, -98.85793],
              [38.17416, -98.85794],
              [38.17415, -98.85728],
              [38.17416, -98.85669],
              [38.17417, -98.85609],
              [38.17418, -98.8555],
              [38.17419, -98.8549],
              [38.1742, -98.85431],
              [38.17421, -98.85371],
              [38.17422, -98.85312],
              [38.17424, -98.85252],
              [38.17425, -98.85193],
              [38.17426, -98.85133],
              [38.17427, -98.85074],
              [38.17428, -98.85014],
              [38.17429, -98.84955],
              [38.1743, -98.84895],
              [38.17431, -98.84836],
              [38.17432, -98.84761],
              [38.17432, -98.84685]
            ],
            freeDraw: undefined
          }
        ],
        distance: 1991.79,
        elevationGain: 0,
        estimatedTime: {
          value: '0.5–1',
          unit: 'hr'
        }
      },
      {
        id: 4,
        serverId: 53450256004,
        color: '#f87559',
        elevationPoints: [
          [
            0,
            595,
            [38.1075, -98.86169],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            0,
            596,
            [38.1075, -98.86106],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            55.12142219894304,
            594,
            [38.1075, -98.86043],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            110.24284439788607,
            594,
            [38.1075, -98.8598],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            165.36426659558492,
            595.89,
            [38.10749, -98.85916],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            221.37167505911202,
            594.89,
            [38.10749, -98.85853],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            276.4931048035287,
            594,
            [38.10749, -98.8579],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            331.61453454794537,
            594,
            [38.10701, -98.8579],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            384.98817305960256,
            594.36,
            [38.10653, -98.8579],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            438.36181157204555,
            594,
            [38.10604, -98.85791],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            492.854425695572,
            594.95,
            [38.10556, -98.85791],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            546.228064208015,
            595.94,
            [38.10508, -98.85791],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            599.6017027196722,
            595,
            [38.1046, -98.85791],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            652.9753412321152,
            594,
            [38.10411, -98.85791],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            707.4609305464619,
            594,
            [38.10363, -98.85791],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            760.8345690581191,
            594,
            [38.10315, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            814.2153792787649,
            594,
            [38.10267, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            867.5890177904221,
            594,
            [38.10218, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            922.0746071055546,
            594,
            [38.1017, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            975.4482456172118,
            594,
            [38.1012, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1031.0457857342408,
            594,
            [38.10058, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ],
          [
            1099.986735478793,
            594,
            [38.09996, -98.85792],
            {
              currentTime: 0,
              elapsedTime: 0
            }
          ]
        ],
        paths: [
          {
            points: [
              [38.1075, -98.86169],
              [38.1075, -98.86106],
              [38.1075, -98.86043],
              [38.1075, -98.8598],
              [38.10749, -98.85916],
              [38.10749, -98.85853],
              [38.10749, -98.8579],
              [38.10701, -98.8579],
              [38.10653, -98.8579],
              [38.10604, -98.85791],
              [38.10556, -98.85791],
              [38.10508, -98.85791],
              [38.1046, -98.85791],
              [38.10411, -98.85791],
              [38.10363, -98.85791],
              [38.10315, -98.85792],
              [38.10267, -98.85792],
              [38.10218, -98.85792],
              [38.1017, -98.85792],
              [38.1012, -98.85792],
              [38.10058, -98.85792],
              [38.09996, -98.85792]
            ],
            freeDraw: undefined
          }
        ],
        distance: 1168.24,
        elevationGain: 2,
        estimatedTime: {
          value: '0.5–1',
          unit: 'hr'
        }
      }
    ],
    waypoints: [
      {
        id: 0,
        serverId: 109604656,
        name: 'test 1',
        description: 'desc 1',
        latitude: 38.14434,
        longitude: -98.79372,
        showTitle: true
      },
      {
        id: 1,
        serverId: 109604657,
        name: 'test 2',
        description: 'desc 2',
        latitude: 38.14101,
        longitude: -98.78621,
        showTitle: false
      }
    ],
    createdAt: '2025-04-07T19:33:47Z',
    location: {
      postalCode: null,
      city: 'St. John',
      region: 'KS',
      country: 'US',
      country_id: 313,
      latitude: '38.20333',
      longitude: '-98.81078'
    }
  },
  map: stubbedCustomRouteMap
};
